<template>
  <v-app class="user-managment-layout-page">
    <HeaderToolbar
      :renderSideIcon="true"
      :renderRightMenuButtons="true"
      :fixed="true"
      :extended="true"
      :extensionHeight="'48px'"
    >
      <v-toolbar-title slot="header-extension" class="white--text ma-0">
        <v-btn
          small
          icon
          @click="toggleLineList"
          :title="messages.MENU_BUTTON_TITLE">
          <v-icon>view_list</v-icon>
        </v-btn>
        {{ this.$route.meta.headerTitle}}
      </v-toolbar-title>
      <HeaderActions slot="actions" />
    </HeaderToolbar>
    <UsersManagementSideBar
      :menu-items="menuItemsFiltered"
      :show="drawer1"
      @visibility-changed="onListVisibilityChanged"
    />
    <v-content>
      <v-container pa-0 fluid fill-height>
        <slot />
      </v-container>
      <SnackbarNotification />
    </v-content>
    <SatFooter />
  </v-app>
</template>

<script>
import SnackbarNotification from '@/components/common/SnackbarNotification.vue';
import SatFooter from '@/components/common/Footer.vue';
import HeaderToolbar from '@/components/common/HeaderToolbar.vue';
import UsersManagementSideBar from '@/components/UsersManagement/SideBar/UsersManagementSideBar.vue';
import HeaderActions from '@/components/common/HeaderActions.vue';

export default {
  components: {
    SnackbarNotification,
    SatFooter,
    HeaderToolbar,
    UsersManagementSideBar,
    HeaderActions,
  },
  data() {
    return {
      drawer1: this.$vuetify.breakpoint.smAndUp,
      menuItems: [
        {
          name: 'Suppliers',
          goToPath: '/users/suppliers',
          subjectName: 'SuppliersManagement',
        },
        {
          name: 'Employees',
          goToPath: '/users/employees',
          subjectName: 'EmployeeManagement',
        },
      ],
      messages: {
        MENU_BUTTON_TITLE: 'Show/Hide Users sidebar',
      },
    };
  },
  computed: {
    menuItemsFiltered() {
      const self = this;

      return this.menuItems.filter((mi) => self.$isAllowed('view', mi.subjectName));
    },
  },
  methods: {
    onListVisibilityChanged(show) {
      this.drawer1 = show;
    },
    toggleLineList() {
      this.drawer1 = !this.drawer1;
    },
  },
};
</script>

<style lang="scss">
  .user-managment-layout-page{
    main{
      background: #f2f2f2;
    }
  }
</style>
